export const weather_seasons = [
  { char: '☀️', name: 'Sun', nameZh: '大晴天', keywords: ['hot', 'weather', 'clear'], hot: true },
  { char: '☁️', name: 'Cloud', nameZh: '多雲轉晴', keywords: ['sky', 'weather'] },
  { char: '🌧️', name: 'Rain', nameZh: '雨天憂鬱', keywords: ['wet', 'sad', 'water'] },
  { char: '❄️', name: 'Snowflake', nameZh: '冬日雪花', keywords: ['cold', 'winter', 'ice'] },
  { char: '⚡', name: 'Voltage', nameZh: '閃電/能量', keywords: ['power', 'storm', 'fast'] },
  { char: '🌈', name: 'Rainbow', nameZh: '彩虹希望', keywords: ['color', 'happy', 'nature'], hot: true },
  { char: '🌡️', name: 'Thermometer', nameZh: '氣溫變化', keywords: ['hot', 'cold', 'fever'] },
  { char: '🌙', name: 'Moon', nameZh: '夜晚時分', keywords: ['night', 'sleep', 'dark'] },
  { char: '🌘', name: 'Waning Moon', nameZh: '月相變化', keywords: ['space', 'night'] },
  { char: '🌕', name: 'Full Moon', nameZh: '滿月/團圓', keywords: ['moon', 'bright', 'round'] },
  { char: '🍂', name: 'Fallen Leaf', nameZh: '秋意濃', keywords: ['autumn', 'fall', 'brown'] },
  { char: '🌸', name: 'Cherry Blossom', nameZh: '春暖花開', keywords: ['pink', 'flower', 'spring'], hot: true },
];